export * from './compact-menu.component';
export * from './compact-menu.module';
